import { render } from "./ProductTableLayout.vue?vue&type=template&id=f4497cc2"
import script from "./ProductTableLayout.vue?vue&type=script&lang=js"
export * from "./ProductTableLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__